import * as actionTypes from './actionTypes';

export const changePaletteType = (isDarkPalette) => {
    return {
        type: actionTypes.CHANGE_PALETTE_TYPE,
        isDarkPalette: isDarkPalette
    };
};